<div *ngIf="mapId==0 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch0" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch0">
  </datalist>
</div>
<div *ngIf="mapId==1 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch1" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch1">
  </datalist>
</div>
<div *ngIf="mapId==2 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch2" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch2">
  </datalist>
</div>
<div *ngIf="mapId==3 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch3" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch3">
  </datalist>
</div>
<div *ngIf="mapId==4 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch4" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch4">
  </datalist>
</div>
<div *ngIf="mapId==5 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch5" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch5">
  </datalist>
</div>
<div *ngIf="mapId==6 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch6" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch6">
  </datalist>
</div>
<div *ngIf="mapId==7 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch7" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch7">
  </datalist>
</div>
<div *ngIf="mapId==8 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch8" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch8">
  </datalist>
</div>
<div *ngIf="mapId==9 && !noSearch" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearch9" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearch9">
  </datalist>
</div>

<div *ngIf="mapId==0" id="mapContainer0" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==1" id="mapContainer1" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==2" id="mapContainer2" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==3" id="mapContainer3" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==4" id="mapContainer4" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==5" id="mapContainer5" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==6" id="mapContainer6" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==7" id="mapContainer7" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==8" id="mapContainer8" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>
<div *ngIf="mapId==9" id="mapContainer9" class="mapa">
  <div class="my-location" (click)="onMyLocation()" title="{{translate('Mi_posicion','Mi posición')}}">
  </div>
</div>